import cookit from '../images/projects/cookit.png';
import pixel from '../images/projects/pixel.png';
import cart from '../images/projects/shopping.png';
import solar from '../images/projects/solar.png';
import todo from '../images/projects/to-do.png';
import tryunfo from '../images/projects/tryunfo.png';
import tunes from '../images/projects/tunes.png';
import warts from '../images/projects/warts.png';
import wallet from '../images/projects/wallet.png';
import blogs from '../images/projects/blogsapi.png';
import dragons from '../images/projects/dragons.png';
import store from '../images/projects/store-manager.png';

export const projects = [
  {
    name: 'CookIT',
    image: cookit,
    about: 'Aplicativo de receitas.',
    git: 'https://github.com/melobrunoti/app-de-receitas',
    liveRepo: 'https://melobrunoti.github.io/app-de-receitas/',
  },
  {
    name: 'TrybeWallet',
    image: wallet,
    about: 'Carteira de controle de gastos com conversor de moedas.',
    git: 'https://github.com/melobrunoti/TrybeWallet',
    liveRepo: 'https://melobrunoti.github.io/TrybeWallet/',
  },
  {
    name: 'Trybe Tunes',
    image: tunes,
    about: 'Aplicativo de músicas',
    git: 'https://github.com/melobrunoti/trybe-tunes',
    liveRepo: 'https://melobrunoti.github.io/trybe-tunes/#/',
  },
  {
    name: 'Solar System',
    image: solar,
    about: 'Sistema solar listando algumas missões espaciais históricas',
    git: 'https://github.com/melobrunoti/Solar-System.',
    liveRepo: 'https://melobrunoti.github.io/Solar-System/',
  },
  {
    name: 'Tryunfo',
    image: tryunfo,
    about: 'Jogo de cartas super trunfo inspirado no MMORPG Dofus',
    git: 'https://github.com/melobrunoti/tryunfo',
    liveRepo: 'https://melobrunoti.github.io/tryunfo/',
  },
  {
    name: 'Shopping Cart',
    image: cart,
    about: 'Carrinho de compras utilizando API do mercado livre.',
    git: 'https://github.com/melobrunoti/shopping-cart',
    liveRepo: 'https://melobrunoti.github.io/shopping-cart/',
  },
  {
    name: 'Trybe Warts',
    image: warts,
    about: 'Formulário inspirado na escola Hogwarts.',
    git: 'https://github.com/melobrunoti/TrybeWarts',
    liveRepo: 'https://melobrunoti.github.io/shopping-cart/',
  },
  {
    name: 'To-do-List',
    image: todo,
    about: 'Lista de tarefas.',
    git: 'https://github.com/melobrunoti/to-do-list-js',
    liveRepo: 'https://melobrunoti.github.io/to-do-list-js/',
  },
  {
    name: 'Pixel Art',
    image: pixel,
    about: 'App de criação de pixel art.',
    git: 'https://github.com/melobrunoti/Pixel-art',
    liveRepo: 'https://melobrunoti.github.io/Pixel-art/',
  },
];

export const backEndProjects = [
  {
    name: 'Blogs-Api',
    about: 'Uma API de um blog usando express e sequelize.',
    image: blogs,
    git: 'https://github.com/melobrunoti/Blogs-API',
  },
  {
    name: 'Trybers And Dragons',
    image: dragons,
    about: 'Universo rpg com arquitetura SOLID e princípios de POO.',
    git: 'https://github.com/melobrunoti/Trybers-and-Dragons',
  },
  {
    name: 'Store Manager',
    image: store,
    about: 'Store manager REST API com express.',
    git: 'https://github.com/melobrunoti/Store-Manager',
  },
];
